import LoadingCenter from './util/LoadingCenter';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import UsersToils from './toilsComponents/UsersToils';
import SidePanel from './util/SidePanel';
import { useLocation } from "react-router-dom";
import UserToilsAdd from './modal/UserToilsAdd';
import UserToilsView from './modal/UserToilsView';
import { t } from 'i18next';
import SearchFilter from './util/SearchFilter';

interface User {
  id: number;
  first_name: string;
  last_name: string;
  second_name: string;
  email: string;
  date_of_birth: Date;
  contract_start_date: Date;
  pattern: {
    title: string
  };
  sex: string;
  mobile_phone: string;
  postcode: string;
  city: string;
  address: string;
  job_title: string;
  min_leave_entitlement: number;
  role: {
    id: number,
    title: string
  },
  company: {
    id: number,
    title: string
  },
  supervisorId: number;
}

interface UsersProps {
  access: any,
  baseUrl: string,
  listOnly?: boolean,
}

const Toils: React.FC<UsersProps> = ({ access, baseUrl, listOnly = false }) => {
  const [users, setUsers] = useState<User[]>([]);
  const [originalUsers, setOriginalUsers] = useState<User[]>([]);
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const [selectedUserToils, setSelectedUserToils] = useState<User | null>(null);
  const auth = useSelector((state: RootState) => state.auth.value);
  const [showModalToils, setShowModalToils] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState('');
  const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());

  const handleShow = (user: User) => {
    setSelectedUser(user);
    setShow(true);
  };

  const handleShowToils = (user: User) => {
    setSelectedUserToils(user);
    setShowModalToils(true);
  };

  const refreshToils = async () => {
    setLoading(true);
    try {
      const { data: usersData } = await axios.get(`users/toil?year=${selectedYear}`);
      setUsers(usersData);
      setOriginalUsers(usersData);
    } catch {
      // handled globally
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const { data: usersData } = await axios.get(`users/toil?year=${selectedYear}`);
        setUsers(usersData);
        setOriginalUsers(usersData);
      } catch {
        // handled globally
      } finally {
        setLoading(false);
      }
    })();
  }, [dispatch, location.pathname, selectedYear]);

  if (listOnly) {
    return (
      <>
        {auth && access.toil_enabled ? (
          <div className='box-users flex flex-col justify-start rounded-[5px] mb-[15px]'>
            {(Array.isArray(users) && users.length > 0) || !loading ? (
              <UsersToils
                access={access}
                users={users}
                handleShow={handleShow}
                handleShowToils={handleShowToils}
                selectedContractFilter={null}
                baseUrl={baseUrl}
              />
            ) : (
              <LoadingCenter />
            )}
          </div>
        ) : (
          <LoadingCenter />
        )}
        <SidePanel open={show} onClose={() => setShow(false)}>
          {selectedUser && <UserToilsView selectedUser={selectedUser} refreshUsers={refreshToils} />}
        </SidePanel>
        <SidePanel open={showModalToils} onClose={() => setShowModalToils(false)}>
          <UserToilsAdd refreshUsers={refreshToils} setShowModalToils={setShowModalToils} selectedUserToils={selectedUserToils} />
        </SidePanel>
      </>
    );
  }

  const yearNow = new Date().getFullYear();

  return (
    <>
      {auth && access.toil_enabled ? (
        <div className='box-users flex flex-col justify-start rounded-[5px] mb-[15px]'>
          {/* Toolbar */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: 'var(--space-l1) var(--space-l1) var(--space-l2)', flexWrap: 'wrap' }}>
            <SearchFilter
              columns={[]}
              search={search}
              onSearch={v => {
                setSearch(v);
                const q = v.toLowerCase();
                setUsers(q ? originalUsers.filter(u =>
                  u.last_name.toLowerCase().includes(q) ||
                  u.first_name.toLowerCase().includes(q)
                ) : originalUsers);
              }}
              filters={[]}
              onFilters={() => {}}
              placeholder={t('fillter') || 'Search...'}
            />
            <select
              className="timesheet-edit-input rounded-[8px]"
              style={{ height: 32, fontSize: 12, padding: '0 8px' }}
              value={selectedYear}
              onChange={e => setSelectedYear(Number(e.target.value))}>
              {Array.from({ length: yearNow - 2019 }, (_, i) => yearNow - i).map(y => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
          </div>
          {(Array.isArray(users) && users.length > 0) || !loading ? (
            <UsersToils
              access={access}
              users={users}
              handleShow={handleShow}
              handleShowToils={handleShowToils}
              selectedContractFilter={null}
              baseUrl={baseUrl}
            />
          ) : (
            <LoadingCenter />
          )}
        </div>
      ) : (
        <LoadingCenter />
      )}
      <SidePanel open={show} onClose={() => setShow(false)}>
        {selectedUser && <UserToilsView selectedUser={selectedUser} refreshUsers={refreshToils} />}
      </SidePanel>
      <SidePanel open={showModalToils} onClose={() => setShowModalToils(false)}>
        <UserToilsAdd refreshUsers={refreshToils} setShowModalToils={setShowModalToils} selectedUserToils={selectedUserToils} />
      </SidePanel>
    </>
  );
};

export default Toils;
